module.exports = __webpack_public_path__ + "static/img/discord.4175648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/clix/discord/discord.png
// module id = 7IPV
// module chunks = 35